import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CurrencyService } from 'src/app/util/currency.service';
import {
  EARNING_LOYALTY,
  SCAN_QR_AD,
  CLOSE_TRANSPARENT,
  QR_RANK,
  INFO_TRANSPARENT,
  WHITE_BACK_ARROW,
  SCAN_N_WIN,
  SCAN_N_WIN_ROBO,
  SCAN_N_WINPRIZE,
  SCAN_DISQUALIFED,
  SCAN_N_WIN_PREV_WINNER,
  SCAN_N_WIN_RIGHT_ARROW,
  SCAN_N_WIN_CURRENT_WINNER,
  SCAN_N_WIN_TNC
} from 'src/defaultImages.js';
import { LocalStorageService } from '../../services/localStorage.service';
import { ApiService } from '../../services/api.service';
import { MessageService } from '../../services/message.service';

@Component({
  selector: 'app-scan-qr-ad',
  templateUrl: './scan-qr-ad.component.html',
  styleUrls: ['./scan-qr-ad.component.css'],
})
export class ScanQrAdComponent implements OnInit {
  images = {
    EARNING_LOYALTY: EARNING_LOYALTY,
    SCAN_QR_AD: SCAN_QR_AD,
    CLOSE_TRANSPARENT: CLOSE_TRANSPARENT,
    QR_RANK: QR_RANK,
    INFO_TRANSPARENT: INFO_TRANSPARENT,
    WHITE_BACK_ARROW: WHITE_BACK_ARROW,
    SCAN_N_WIN: SCAN_N_WIN,
    SCAN_N_WINROBO:SCAN_N_WIN_ROBO,
    SCAN_N_WINPRIZE:SCAN_N_WINPRIZE,
    SCAN_DISQUALIFED: SCAN_DISQUALIFED,
    SCAN_N_WIN_PREV_WINNER: SCAN_N_WIN_PREV_WINNER,
    SCAN_N_WIN_RIGHT_ARROW: SCAN_N_WIN_RIGHT_ARROW,
    SCAN_N_WIN_CURRENT_WINNER: SCAN_N_WIN_CURRENT_WINNER,
    SCAN_N_WIN_TNC: SCAN_N_WIN_TNC,
  };
  startDate: Date = new Date('2025-08-25T00:00:00');
  endDate: Date = new Date('2025-08-30T23:59:59');
  Currency = '';
  subscription = new Subscription();
  popupIndex: number;
  loader: boolean = false;
  countdown: string = '';
  scanNWinData: any = [];
  showAll: boolean = true;
  loading: boolean = false;
  showOnlyWinner: boolean = false;
  inEligibilityReason: string = '';
  rest_id: string;
  constructor(
    public dialogRef: MatDialogRef<any>,
    private curr: CurrencyService,
    private _localStorage: LocalStorageService,
    private _messageService: MessageService,
    private apiService: ApiService
  ) {
    this.Currency = this.curr.getCurrency();
    this.rest_id = this._localStorage.get('restaurant_id');
  }

  ngOnInit() {
    this.getDates()
  }

  getDates(): void {
    this.loader = true;
    this.apiService.getScanNWinDates().subscribe(
      (response) => {
        if (response?.status === 1) {
          this.loader = false;
          const startDate = new Date(response?.data?.sw_start_date);
          const endDate = new Date(response?.data?.sw_end_date);
          if (this.isValidDate(startDate) && this.isValidDate(endDate)){ 
            this.startDate = startDate;
            this.endDate = endDate;
          }
          this.getScanNWin();
          // this.setCountdownTimer();
          this.setShowAll();
        } else {
          this.loader = false;
          this._messageService.showError('An unexpected error occurred');
          console.error(response?.message);
        }
      },
      (error) => {
        this.loader = false;
        console.error(error)
      }
    );
  }

  private isValidDate(date: any): boolean {
    return date instanceof Date && !isNaN(date.getTime());
  }

  setShowAll() {
    const now = new Date();
    if (
      now.getTime() >= this.startDate.getTime() &&
      now.getTime() <= this.endDate.getTime()
    ) {
      this.showAll = true;
      this.popupIndex = 1;
    } else if(now.getTime() < this.startDate.getTime()) {
      this.showAll = false;
      this.popupIndex = 0;
    }else{
      this.showAll = false;
      this.popupIndex = 4;
      this.showOnlyWinner = true;
    }
  }

  setCountdownTimer() {
    // Set the target date and time
    const targetDate = this.endDate; // Replace with your desired future date

    // Update the countdown every second
    setInterval(() => {
      const now = new Date();
      const timeDifference = targetDate.getTime() - now.getTime();

      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      );

      this.countdown = `${days} Days : ${hours} Hr : ${minutes} Min`;
    }, 1000);
  }

  replaceEvenCharsWithX(inputString) {
    let words = inputString.split(' ');

    for (let i = 0; i < words.length; i++) {
      let wordArray = words[i].split('');

      for (let j = 1; j < wordArray.length; j += 2) {
        // Replace every even-indexed character with 'x'
        wordArray[j] = '_';
      }

      words[i] = wordArray.join('');
    }

    return words.join(' ');
  }

  cancel() {
    this.dialogRef.close({
      status: 0,
      data: null,
      message: 'closed',
    });
  }

  changePopupIndex(index: number) {
    this.popupIndex = index;
  }

  getScanNWin() {
    this.loading = true;
    this.apiService.getScanNWinData(this.rest_id).subscribe(
      (res: any) => {
        this.scanNWinData = res?.data?.leaderboard;
        if(this.scanNWinData.length === 11){
          this.scanNWinData[9] = this.scanNWinData[10];
          this.scanNWinData.pop();
        }
        const restData = (this.scanNWinData.find(res=>(res || {}).restaurant_id === this.rest_id) || {});
        if(restData.eligible === 'No'){
          this.inEligibilityReason = restData.reason_for_ineligibility || ''
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
